import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите назначение здания", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: жилое, нежилое", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Информация о конструкции", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: настенная вывеска \"РОСБАНК\"", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите габаритные размеры", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Введите значение текстом, в мм. Пример: 2 х 2 мм", -1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Принцип крепления", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: монтажная рама 20х20 мм", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Место размещения", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: фриз козырька", -1)
const _hoisted_15 = {
  key: 1,
  class: "step__basic"
}
const _hoisted_16 = { class: "left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Информация о лицевой части", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Нерж сталь 1мм, окрашенная в RAL 3020 и 5013", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Информация о боковине", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Нерж сталь 0,7 мм, окрашенная в RAL 5013", -1)
const _hoisted_21 = { class: "right" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Информация о подсветке", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Светодиодные кластеры ECO - 2 - W", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Информация о задней части", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: Орг. стекло 4 мм", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subpage = 1))
      }, "Шаг 1", 2),
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 2}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.subpage = 2))
      }, "Шаг 2", 2)
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите назначение здания",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.purpose_building) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.purpose_building]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите информацию о конструкции",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.construction_info) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.construction_info]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите значение размеров",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.size) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.size]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите принцип крепления",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.binding) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.binding]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_13,
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите место размещения",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.document.place) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.place]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _hoisted_17,
              _hoisted_18,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden","height":"180px"},
                class: "input",
                type: "text",
                placeholder: "Введите информацию о лицевой части",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.document.info_front) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.info_front]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _hoisted_20,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden","height":"180px"},
                class: "input",
                type: "text",
                placeholder: "Введите информацию о боковине",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.document.info_side) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.info_side]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _hoisted_22,
              _hoisted_23,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden","height":"180px"},
                class: "input",
                type: "text",
                placeholder: "Введите информацию о подсветке",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.document.info_light) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.info_light]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_24,
              _hoisted_25,
              _withDirectives(_createElementVNode("textarea", {
                style: {"resize":"none","overflow":"hidden","height":"180px"},
                class: "input",
                type: "text",
                placeholder: "Введите информацию о задней части",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.document.info_back) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.info_back]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}